// @flow
import * as React from 'react';
import styled from 'styled-components';
import type { AccordionBlockData } from 'api/cms';
import Button from 'components/Button';
import Flex from 'components/Flex';
import Box from 'components/Box';
import { RichTextHeadline, H4, Body } from 'components/Text';
import AccordionGroupContainer from 'containers/AccordionGroupContainer';
import { colors } from '../../theme';

const AccordionSection = styled.div`
  border-bottom: 1px solid ${colors.silver};
`;

const AccordionTitle = ({
  onClick,
  toggled,
  index,
  title
}: {
  onClick: Function,
  toggled: boolean,
  index: number,
  title: string
}) => (
  <Button
    onClick={onClick}
    aria-controls={`accordionSection${index}`}
    aria-expanded={toggled}
    width="100%"
  >
    <H4 m="0" py="30px">
      <Flex
        justifyContent="space-between"
        width="100%"
        alignItems="center"
        textAlign="left"
      >
        <span>{title}</span>
        <span>{toggled ? '-' : '+'}</span>
      </Flex>
    </H4>
  </Button>
);

const AccordionBlock = ({
  blockIndex,
  data: { sections, default: defaultState, headline, subtitle },
  fullWidthLayout
}: {
  blockIndex: number,
  data: AccordionBlockData,
  fullWidthLayout?: boolean
}) => (
  <Box>
    {(headline || subtitle) && (
      <Box mb={64} textAlign={fullWidthLayout ? 'center' : 'left'}>
        {headline && <RichTextHeadline>{headline}</RichTextHeadline>}
        {subtitle && (
          <Body
            analyticsData={{
              eventName: 'CMS Block',
              eventProperties: {
                block_position: blockIndex,
                block_type: 'Accordion'
              }
            }}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}
      </Box>
    )}
    <AccordionGroupContainer
      defaultValue={defaultState === 'FIRST_ONE_OPENED' ? 0 : -1}
      render={(toggle, current) =>
        sections.map((section, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <AccordionSection key={`${section.title}-${index}`}>
            <Box mt={index === 0 ? '-30px' : 0}>
              <AccordionTitle
                onClick={() => toggle(index)}
                toggled={index === current}
                index={index}
                title={section.title}
              />
            </Box>
            {index === current && (
              <Box pb="30px">
                <Body
                  id={`accordionSection${index}`}
                  analyticsData={{
                    eventName: 'CMS Block',
                    eventProperties: {
                      block_position: blockIndex,
                      block_type: 'Accordion'
                    }
                  }}
                  dangerouslySetInnerHTML={{ __html: section.content }}
                  m="0"
                />
              </Box>
            )}
          </AccordionSection>
        ))
      }
    />
  </Box>
);

export default AccordionBlock;
